import React from "react";
import { Route, Redirect, useLocation, matchPath } from "react-router-dom";
import { useUser } from "../context";
import Page from "../components/Page";
import GlobalSpinner from "../components/Spinner";

const pass = ["/customers/list/:type/:id?", "/explore-brands"];
function PrivateRoute({ component: Component, ...rest }) {
	const { pathname } = useLocation();
	const res = matchPath(pathname, {
		path: pass,
		exact: true,
		strict: false,
	});
	const {
		isLogged,
		isloading,
		tokens: { group },
		brand,
	} = useUser();
	return (
		<Route
			{...rest}
			render={(props) =>
				isLogged ? (
					group === "admin" && !brand && !pass.includes(res?.path) ? (
						<Redirect
							to={{
								pathname: "/explore-brands",
								state: { from: props.location },
							}}
						/>
					) : (
						<Page>
							<Component {...props} />
						</Page>
					)
				) : isloading ? (
					<GlobalSpinner />
				) : (
					<Redirect
						to={{ pathname: "/sign-in", state: { from: props.location } }}
					/>
				)
			}
		/>
	);
}

export default PrivateRoute;
